import { GRAPH_CMS_CDN } from '../constant';

const getOptimalGraphImg = (graphSrc = '') => {
  const slashIndex = graphSrc.lastIndexOf('/');
  const path = graphSrc.slice(slashIndex + 1);
  return `${GRAPH_CMS_CDN}/${path}`;
};

export default getOptimalGraphImg;
